<ng-container *ngIf="control && control.value">
  {{ control.value.length || 0 }}/{{ maxlength }}
</ng-container>
